export const enum PpuMode {
  HBlank = 0,
  VBlank = 1,
  OamSearch = 2,
  PixelTransfer = 3,
}
